export default function getStatus(setUser, serverOrigin, setUserLoading) {
	return new Promise((resolve, reject) => {
		let currentID = localStorage.getItem('userID');

		if (!currentID) {
			console.log('Not logged in');
			if (setUserLoading) {
				setUserLoading(false);
			}
			reject({message: 'Not logged in'});
			return;
		}
		fetch(`${serverOrigin}/getProfile/${currentID}`, {
			method: 'get',
			credentials: 'include',
		})
			.then(req => {
				return req.json();
			})
			.then(req => {
				setUser(req.user);
				console.log(`Sucessfully ran get auth info route from server`);
				resolve(req.user);
			})
			.catch(err => {
				console.error(`Something went wrong in get status api caller function because ${err.message}`);
				reject(err);
			})
			.finally(() => {
				if (setUserLoading) {
					setUserLoading(false);
				}
			});
	});
}
